module.exports = __webpack_public_path__ + "assets/img/title-644a4873.png";